import * as React from 'react';
import {Typography} from '@mui/material';

/**
 * Plain block -- the caller decides whether it sits in a Grid item or a Stack.
 * `underline` mimics a disabled input, so read-only values can sit in a form row
 * next to real fields without looking out of place.
 */
export const ReadOnlyField = ({label, value, hint, underline}: {
    label: string,
    value?: React.ReactNode,
    hint?: string,
    underline?: boolean,
}) => <div>
    {/* Figma draws no read-only field: its only two references are the active label
        (#212121, the same as the value) and the disabled one (#A6A6A6). Full black made
        the label compete with the value, the disabled grey dropped out of the column
        altogether, so this sits between them on the existing token. */}
    <Typography component={'div'} sx={{fontSize: '12px', color: 'var(--color-black-text)'}}>{label}</Typography>
    <Typography component={'div'} sx={{
        fontSize: '16px',
        paddingTop: '2px',
        minHeight: '24px',
        wordBreak: 'break-word',
        ...(underline ? {paddingBottom: '5px', borderBottom: '1px solid rgba(0, 0, 0, 0.42)'} : {})
    }}>
        {(value || value === 0) ? value : '-'}
    </Typography>
    {!!hint && <Typography component={'div'} sx={{fontSize: '12px', color: 'var(--color-black-inactive)', paddingTop: '4px'}}>{hint}</Typography>}
</div>;
